import { render, staticRenderFns } from "./EditarMultiplosProdutos.vue?vue&type=template&id=aed9ebfc"
import script from "./EditarMultiplosProdutos.vue?vue&type=script&lang=js"
export * from "./EditarMultiplosProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports